<template>
  <div>
    <base-header class="pb-6" type>
      <div class="row align-items-center py-4">
        <breadcrumbs :header="$t('Courses')"></breadcrumbs>
        <div class="col-lg-6 col-5 text-right">
          <router-link :to="{name: 'add-course'}">
            <base-button type="primary">
              <i class="ni ni-fat-add mr-2"></i>
              {{ $t('new course') }}
            </base-button>
          </router-link>
        </div>
      </div>
    </base-header>

    <v-wait for="course list fetching">
      <template slot="waiting">
        <div class="container loader">
          <div class="row justify-content-md-center">
            <div class="col-md-auto">
              <spinner></spinner>
            </div>
          </div>
        </div>
      </template>
      <div class="container-fluid mt--6">
        <div class="row">
          <div class="col">
            <div class="card bg-transparent">
              <el-table
                class="table-responsive"
                header-row-class-name="thead-light"
                empty-text="У вас нету ни одного курса."
                :data="courses"
              >
                <el-table-column :label="$t('course title')" min-width="310px" prop="title">
                  <template v-slot="{row}">
                    <router-link :to="{name: 'content-list', params: {courseId: row.name}}">
                      {{ row.title }}
                    </router-link>
                    <input :id="`course-${row.id}`"
                           type="hidden"
                           :value="absolutePublicUrl(row.publicUrl)"/>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('payment')" prop="isPaid" min-width="70px">
                  <template v-slot="{row}">
                    <span v-if="row.isPaid">
                      <i class="fa fa-check-circle text-success" :title="$t('paid')"></i>
                    </span>
                    <span v-else>
                      <i class="fa fa-times text-light" :title="$t('no price')"></i>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('status')" min-width="100px" prop="status">
                  <template v-slot="{row}">
                    <span v-if="row.status === 'published'">
                      <i class="fa fa-check-circle text-success" :title="$t('published')"></i>
                    </span>
                    <span v-if="row.status === 'unpublished'">
                      <i class="fa fa-times text-danger" :title="$t('unpublished')"></i>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('students')" min-width="100px" prop="students">
                  <template v-slot="{row}">
                    <badge type="primary">{{ row.userCount }}</badge>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('actions')" min-width="200px">
                  <template v-slot="{row}">
                    <router-link :to="{name: 'content-list', params: {courseId: row.name}}">
                      <base-button size="sm" outline type="secondary">
                        <i class="fa fa-edit"></i>
                      </base-button>
                    </router-link>
                    <router-link :to="{name: 'learn-course-content', params: {courseId: row.name}}">
                      <base-button size="sm" outline type="secondary">
                        <i class="fa fa-eye"></i>
                      </base-button>
                    </router-link>
                    <base-button
                      size="sm"
                      @click.stop.prevent="copyPublicUrlToClipboard(row.id)"
                      class="ml-2 public-url"
                      outline
                      type="secondary">
                      <i class="fa fa-link fa-sm"></i>
                      <span class="show-on-hover">
                        {{ $t('copy') }}
                      </span>
                    </base-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="card bg-transparent">
              <p>
                Если курс не опубликован, то он не доступен для доступа студентам.
                Опубликовать курс можно в настройках курса
              </p>
            </div>
          </div>
        </div>
      </div>
    </v-wait>
  </div>
</template>
<script>
import Breadcrumbs from "../../Layout/Breadcrumbs.vue";
import { Table, Tooltip, TableColumn } from "element-ui";
import Spinner from "vue-spinner-component/src/Spinner.vue";

export default {
  name: "CourseList",
  metaInfo() {
    return {
      title: this.$i18n.t("Course list"),
    };
  },
  components: {
    Breadcrumbs,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Spinner,
  },
  created() {
    this.fetchData();
  },
  computed: {
    courses() {
      return this.$store.state.course.courses;
    },
  },
  watch: {
    $route: "fetchData",
  },
  methods: {
    async fetchData() {
      this.$wait.start("course list fetching");
      await this.$store.dispatch("course/loadCourses");
      this.$wait.end("course list fetching");
    },
    absolutePublicUrl(path) {
      return `${document.location.origin}${path}`
    },
    copyPublicUrlToClipboard(id) {
      const copyText = document.getElementById(`course-${id}`);
      copyText.setAttribute('type', 'text');
      copyText.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        alert('Oops, unable to copy');
      }
      copyText.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    }
  },
};
</script>
<style lang="scss">
.show-on-hover {
  display: none;
}

.public-url {
  padding: 0.15rem 0.25rem;
  i {
    margin-right: 0.15rem !important;
  }
  &:hover {
    .show-on-hover {
      display: inherit;
    }
  }
}
</style>
